import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_RAF_SCHEMA = Object.freeze({});
const RECORD = generateSchema(TRACKING_RAF_SCHEMA);
const KEYS: any = generateKeys(TRACKING_RAF_SCHEMA);

export class RafTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.raf;
  }

  get properties() {
    return this.toJS();
  }
}
